interface EventParamsInput {
  pageSize: number;
  pageIndex: number;
  sortBy: string;
  searchQuery?: string;
  dateFrom?: string;
  dateTo?: string;
}

/**
 * Builds query params for GET /events.
 * businessID is intentionally omitted: it is NOT in the Joi schema and
 * causes a 400. Without it the API returns all events (no scoping for admin).
 * Date params use fromDate/toDate (API names), not dateFrom/dateTo.
 */
export function buildEventParams(input: EventParamsInput): Record<string, any> {
  const { pageSize, pageIndex, sortBy, searchQuery, dateFrom, dateTo } = input;
  const params: Record<string, any> = {
    limit: pageSize,
    page: pageIndex,
    sortBy,
  };
  if (searchQuery) params.name = searchQuery;
  if (dateFrom) params.fromDate = dateFrom;
  if (dateTo) params.toDate = dateTo;
  return params;
}
